// extracted by mini-css-extract-plugin
export default {"product_images":"ProductImages_product_images__76d7f","img":"ProductImages_img__9Jarr"};